import { useEffect, useState, useMemo } from "react";
import { TextField } from "@pankod/refine-mui";

import axios from "utils/axios";

export default function InputCell({
  value,
  bookings = 0,
  disabled = false,
  accommodationID,
  ratePlanID,
  prezziarioID,
  treatmentID,
  field,
  resource,
  fromDate,
  toDate,
}) {
  const [localValue, setLocalValue] = useState(value);
  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  const handleInputChange = useMemo(() => {
    let timeoutId;

    //a function that delays its execution until after a certain amount of time
    //has passed since the last time it was invoked.
    return function (value) {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        let body = {
          accommodationID,
          ratePlanID,
          prezziarioID,
          treatmentID,
          field,
          resource,
          fromDate: fromDate.toISOString(),
          toDate: toDate.toISOString(),
          value: Number(value) + Number(bookings),
        };
        axios.put("/api/tableau", body);
        //console.log("Send body: " + JSON.stringify(body));
      }, 200);
    };
  }, []);

  return (
    <TextField
      variant="outlined"
      type="text"
      InputProps={{
        style: {
          height: 24,
          margin: 6,
          minWidth: 30,
          fontSize: "12px",
        },
      }}
      inputProps={{
        style: {
          padding: 4,
          textAlign: "center",
        },
      }}
      value={localValue}
      onChange={(e) => {
        handleInputChange(e.target.value);
        setLocalValue(e.target.value);
      }}
      disabled={disabled}
    />
  );
}
